import { RootState } from '@store/store'

export const getSsmlLoading = (state: RootState) => state.ssmls.loading
